export default "__VITE_ASSET__DmNUi8Vp__"